<template>
  <el-container :style="parent" class="parent">
    <el-header>产品信息查询</el-header>
    <el-main>
      <el-row>
        <el-col :span="14">
          <el-form
            ref="form"
            :model="form"
            label-width="140px"
            class="mainform"
            @submit.native.prevent
          >
            <el-form-item label="请输入查询的码:">
              <el-input
                clearable
                type="text"
                v-model="form.qrcode"
                @keyup.native.enter="handleDialogSelectRoom()"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8" :offset="1">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="formlistget"
            v-permission="['informationinquiry_select']"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <br />
      <el-col :span="24">
        <!-- 第一次扫到正品码 -->
        <transition name="el-zoom-in-center">
          <el-card class="box-card" v-show="dialogVisible">
            <div slot="header" class="clearfix">
              <h3>产品详情</h3>
            </div>
            <el-form
              ref="formlist"
              :model="formlist"
              style="text-align: left; margin-bottom: 20px"
              class="mainform"
              center
            >
              <el-row>
                <el-col :span="8">
                  <el-card shadow="hover" class="fanwei">
                    <div slot="header" class="clearfix">
                      <h4>产品信息</h4>
                    </div>
                    <el-form-item label="生产批号:">
                      <div>{{ formlist.batchno }}</div>
                    </el-form-item>
                    <el-form-item label="产品名称:">
                      <div>{{ formlist.productName }}</div>
                    </el-form-item>
                    <el-form-item label="产品品规:">
                      <div>{{ formlist.specs }}</div>
                    </el-form-item>
                    <el-form-item label="产品工厂:">
                      <div>{{ formlist.factory_name }}</div>
                    </el-form-item>
                    <el-form-item label="生产线:">
                      <div>{{ formlist.workline_name }}</div>
                    </el-form-item>
                    <el-form-item label="保质天数:">
                      <div>{{ formlist.qualityPeriod }}</div>
                    </el-form-item>
                    <el-form-item label="有效期:">
                      <div>{{ formlist.periodDate }}</div>
                    </el-form-item>
                    <el-form-item label="查询时间:">
                      <div>{{ formlist.createTime }}</div>
                    </el-form-item>
                    <el-form-item label="查询条码:">
                      <div>{{ formlist.qrcode }}</div>
                    </el-form-item>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover" class="fanwei">
                    <div slot="header" class="clearfix">
                      <h4>物流信息</h4>
                    </div>
                    <el-form-item label="运单号:">
                      <div>{{ formlist.freightBillCode }}</div>
                    </el-form-item>
                    <el-form-item label="发运单号:">
                      <div>{{ formlist.outBillCode }}</div>
                    </el-form-item>
                    <el-form-item label="运单时间:">
                      <div>{{ formlist.freightBillCodeTime }}</div>
                    </el-form-item>
                    <el-form-item label="类型:">
                      <div v-show="formlist.hasfreightBillCode">销售出库</div>
                    </el-form-item>
                    <el-form-item label="配送物流:">
                      <div v-show="formlist.hasfreightBillCode">
                        {{ formlist.enterpriseName
                        }}{{ formlist.from_warehouse }}出到{{
                          formlist.to_warehouse
                        }}
                      </div>
                      <br/>
                      <div
                        v-for="(item, index) in logisticsinfo"
                        :key="index"
                        :is-link="true"
                      >
                        <div slot="title"
                          >发货地址：{{ item.shipperAddress }}</div
                        >
                        <div slot="sub-title"
                          >收货地址：{{ item.shiptoAddress }}</div
                        >
                        <div slot="desc">时间：{{ item.createTime }}</div>
                      </div>
                    </el-form-item>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover" class="fanwei">
                    <div slot="header" class="clearfix">
                      <h4>生产信息</h4>
                    </div>
                    <el-form-item label="生产单号:">
                      <div>{{ formlist.orderno }}</div>
                    </el-form-item>
                    <el-form-item label="生产日期:">
                      <div>{{ formlist.createDate }}</div>
                    </el-form-item>
                    <el-form-item label="类型:">
                      <div v-show="formlist.hasproductionr">生产入库</div>
                    </el-form-item>
                    <el-form-item label="操作:">
                      <div v-show="formlist.hasproductionr">
                        {{ formlist.sworkorderenterpriseName
                        }}{{ formlist.factory_name }}生产入库
                      </div>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
        </transition>
        <!-- 扫到假货 -->
        <el-form
          ref="formlist"
          :model="formlist"
          label-width="140px"
          v-show="Visible"
          class="mainform"
        >
          <div>该产品不是官方正品！</div>
        </el-form>
      </el-col>
    </el-main>
    <!-- <el-footer><el-image :src="src"></el-image></el-footer> -->
  </el-container>
</template>
<script>
import { findallbyqrcode, listtoken } from "@/api/physical";
import { qrcodecount } from "@/api/physical";
import QRCode from "qrcodejs2";
export default {
  name: "home",
  data() {
    return {
      //接口参数
      form: {
        qrcode: "80801114491435481171",
        packageLevel: null,
        pcquery: true, // 区分h5跟后台查询
      },
      formlist: {},
      logisticsinfo: [],
      // 全屏css
      parent: {
        height: "100%",
      },
      footer: {
        height: "200px",
      },
      // 基础数据
      dialogVisible: false,
      Visible: false,
      url: "https://www.baidu.com",
    };
  },
  mounted() {
  },

  methods: {
    // 转化码为二维码
    //     qrcodemk (obj) {
    //         document.getElementById("qrcode").innerHTML = "";// 清除上一个二维码
    //        let qrcode = new QRCode('qrcode',{
    //         width: 200, // 设置宽度，单位像素
    //         height: 200, // 设置高度，单位像素
    //         text: obj   // 设置二维码内容或跳转地址
    //     })
    // },
    // 跟据链接参数调接口
    formlistget() {
      if (this.form.qrcode == "") {
        this.$message({
          message: "请输入码",
          type: "warning",
        });
      } else {
        findallbyqrcode({ qrcode: this.form.qrcode }).then((response) => {
          this.formlist = response.data;
          if (this.formlist.hasworkorder) {
            // 判断是否为产品
            //  this.qrcodemk(this.formlist.qrcode);
            //   this.qrcodemk(this.formlist.qrcode)
            this.dialogVisible = true;
            this.Visible = false;
          } else {
            this.Visible = true;
            this.dialogVisible = false;
          }
          if (this.formlist.logicInfo === 2) {
            qrcodecount({ qrcode: this.form.qrcode, pcquery: true }).then(
              (response) => {
                listtoken({
                  qrcode: response.data.qrcode,
                  level: response.data.packageLevel,
                }).then((response) => {
                  this.logisticsinfo = response.data;
                });
              }
            );
          }
        });
      }
    },
    // enter按下事件#a9a9a969
    handleDialogSelectRoom() {
      this.formlistget();
    },
  },
};
</script>
<style>
.fanwei {
  margin: 5px;
  height: 100%;
}
.el-card__header {
  background-color: #a9a9a969;
}
</style>
<style>
.parent .el-header {
  font-size: 20px;
  height: 50px !important;
  line-height: 50px;
  background-color: #03a9f4;
  color: aliceblue;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.parent .el-footer {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: auto !important;
  margin-bottom: 0px;
  padding: 0 0px;
}
.mainform .el-form-item,
.mainform .el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}
</style>